import React from 'react';
import { RadialChart } from 'react-vis';
import AutoSizer from 'react-virtualized-auto-sizer';

interface DonutProps {
  height?: string;
  innerRadius?: number;
  radius?: number;
  data: any;
}

const Donut = ({ height, innerRadius, radius, data }: DonutProps) => {
  const dataWithNonZeroValue = data && data.filter((a: any) => a.angle !== 0);

  return (
    <div style={{ height: height }}>
      <AutoSizer>
        {({ height, width }: { height: any; width: any }) => {
          return (
            <RadialChart
              width={width}
              height={height}
              data={dataWithNonZeroValue}
              innerRadius={innerRadius}
              radius={radius}
              colorType="literal"
              showLabels
              padAngle={0.02} // space between items
              labelsRadiusMultiplier={0.95} // place of label
              labelsStyle={{
                fill: '#fff'
              }}
            />
          );
        }}
      </AutoSizer>
    </div>
  );
};

export default Donut;
